import React from 'react';
import { Link, Typography } from '@mui/material';
import BlurImageWrapper, { opacities, orientations } from '../BlurImageWrapper';
import { useScreenDetector } from '../../hooks/useScreenDetector';
import { DisplaySettings } from '@mui/icons-material';

const Card = ({
    image,
    href,
    title,
    tagText = null,
    bottomText = null,
    size = 'medium',
}) => {
    const { isMobile } = useScreenDetector();
    const sizeMap = {
        small: { width: '14rem', height: '18rem' },
        medium: { width: '100%', height: '250px' },
        large: { width: '100%', height: '350px' },
    };
    const sizeCard = sizeMap[size];

    return (
        <Link
            underline="none"
            href={href}
            color="primary.contrastText"
            title={"Ver todos los tours privados disponibles en " + title}
        >
            <div className="card" style={{ width: sizeCard.width, height: sizeCard.height }}>
                <div className="subtitle des-sub" style={{ width: '70%' }}>
                    <h3 className="card-title hover-effect des-title">{title}</h3>
                    {tagText && (
                        <Typography
                            color='primary.contrastText'
                            sx={{
                                backgroundColor: '#40C5E8',
                                borderRadius: 4,
                                fontSize: { xs: 14.75, md: 16 },
                                fontFamily: 'Poppins',
                                fontWeight: '600',
                                lineHeight: 1.2,
                                mb: '.2rem',
                                py: '3px',
                                px: '8px',
                                width: 'fit-content'
                            }}
                            className='card-title hover-effect tag'
                        >
                            {tagText}
                        </Typography>
                    )}
                    {bottomText && (
                        <Typography
                            color='primary.contrastText'
                            sx={{
                                fontSize: { xs: 16, md: 18 },
                                fontFamily: 'Inter',
                                fontWeight: { sx: 'regular', md: 'bold' },
                                lineHeight: 1.2,
                            }}
                            className='card-title hover-effect tag'
                        >
                            {bottomText}
                        </Typography>
                    )}
                </div>
                <img
                    src={image}
                    className="card-image img-des"
                />
                <div className="card-overlay des"></div>
            </div>
        </Link>
    )
}

export default Card
